export default __webpack_public_path__ + "static/media/sqlite.0f5fc4ce.png";